import { getFullAddress } from "@/helper/format-data";
import { urbanFeatureValue } from "@/modules/urban-feature/urban-feature.const";
import { UrbanFeature } from "@/modules/urban-feature/urban-feature.types";
import { DescriptionList, DescriptionItem } from "components";
import { toolTipStyle } from "helper/utils";
import { ComponentPropsWithoutRef, useRef } from "react";

export interface UrbanFeatureTooltipProps extends ComponentPropsWithoutRef<"div"> {
  left: number;
  top: number;
  urbanFeature: Omit<UrbanFeature, "geometry">;
}

export const UrbanFeatureTooltip = (props: UrbanFeatureTooltipProps) => {
  const { left, top, urbanFeature } = props;
  const ref = useRef<HTMLDivElement>(null);

  const styles = toolTipStyle({ top, left, height: 207, width: 384 });
  const address = getFullAddress(urbanFeature.address);
  return (
    <div style={styles} className="absolute w-96" ref={ref}>
      <div className="relative transition-opacity h-auto p-3 mt-2 mb-3 rounded-md shadow-lg z-10 bg-primary">
        <div className="text-secondary text-13px mb-4 font-bold">{urbanFeature.name}</div>
        <DescriptionList>
          <DescriptionItem label="Address" value={address} />
          <DescriptionItem label="Type" value={urbanFeatureValue[urbanFeature.type]} />
        </DescriptionList>
      </div>
    </div>
  );
};
